import { createSvgComponent } from "../../icon/createSvgComponent";
import HelpQuestionFill from "@core/__generated__/icon/figma/help-question-fill.svg";
export default createSvgComponent(HelpQuestionFill);